module.exports = __webpack_public_path__ + "img/fieldwork-1985-yanan.5130b3c7.jpg";